import { render, staticRenderFns } from "./BoCAdaptive_Area.vue?vue&type=template&id=8805beee&scoped=true"
import script from "./BoCAdaptive_Area.vue?vue&type=script&lang=js"
export * from "./BoCAdaptive_Area.vue?vue&type=script&lang=js"
import style0 from "./BoCAdaptive_Area.vue?vue&type=style&index=0&id=8805beee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8805beee",
  null
  
)

export default component.exports